/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {ClrIconModule} from '../../icon/icon.module';
import {ClrCommonPopoverModule} from '../../popover/common/popover.module';
import {ClrConditionalModule} from '../../utils/conditional/conditional.module';
import {ClrTemplateRefModule} from '../../utils/template-ref/template-ref.module';

import {TABS_DIRECTIVES} from './index';
export class ClrTabsModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ClrCommonPopoverModule, ClrConditionalModule, ClrIconModule, ClrTemplateRefModule],
    declarations: [TABS_DIRECTIVES],
    exports: [TABS_DIRECTIVES, ClrConditionalModule]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrTabsModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrTabsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrTabsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
